import React, { useContext } from "react";
import GlobalContext from "../../../context/GlobalCalendarContext";

export default function Labels() {
  const { labels, updateLabel } = useContext(GlobalContext);

  const labelColorClasses = {
    indigo: "bg-indigo-200",
    gray: "bg-gray-500",
    green: "bg-green-500",
    blue: "bg-blue-500",
    red: "bg-red-200",
    purple: "bg-purple-200",
  };

  return (
    <React.Fragment>
      <p className="text-gray-500 font-bold mt-10">Label</p>
      {labels.map(({ label: lbl, checked }, idx) => (
        <label
          key={idx}
          className={` flex flex-row  items-center mt-3 p-1 w-40 bg-${lbl}-200 rounded-md cursor-pointer`}
        >
          <input
            type="checkbox"
            checked={checked}
            onChange={() => updateLabel({ label: lbl, checked: !checked })}
            className={`form-checkbox h-5 w-5 accent-${lbl}-500 rounded focus:ring-0 cursor-pointer`}
          />
          <span className={`ml-2 text-gray-700 capitalize`}>{lbl}</span>
        </label>
      ))}
    </React.Fragment>
  );
}
